import { render, staticRenderFns } from "./teacher_portrait_new.vue?vue&type=template&id=348f83eb&scoped=true"
import script from "./teacher_portrait_new.vue?vue&type=script&lang=js"
export * from "./teacher_portrait_new.vue?vue&type=script&lang=js"
import style0 from "./teacher_portrait_new.vue?vue&type=style&index=0&id=348f83eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f83eb",
  null
  
)

export default component.exports